/**
 * reset css & global css
 */
import 'normalize.css';
import './global';
import 'regenerator-runtime';
import './polyfill';
import notifyAdmin from './notify-admin';
const importAll = (r) => {
  r.keys().forEach(r);
};
// eslint-disable-next-line no-undef
importAll(require.context('./styles', true, /\.css$/));

window.addEventListener('unhandledrejection', (ev) => {
  const reason = ev.reason?.message || '';
  if (typeof reason == 'string' && reason.toLowerCase().includes('permission')) {
    return;
  }
  const stack = ev.reason?.stack || '';
  const errMessage = `URL: ${location.href}
  環境: ${navigator.userAgent}
  (UnhandledRejection)
  ${stack}`;
  if (errMessage.includes('safari-extension://')
    || errMessage.includes('chrome-extension://')
    || errMessage.includes('webkit-masked-url://hidden')
    || errMessage.includes('IndexedDB API missing')) {
    return;
  }
  if (stack.trim() === '' && reason.trim() === '') {
    return;
  }
  notifyAdmin(errMessage, reason);
});

window.onerror = (msg, file, line, col, err) => {
  if (file?.includes('chrome-extension://')
    || file?.includes('safari-extension://')
    || msg == 'Script error.'
    || String(msg).includes('registerMyClickListener')
    || String(msg).includes('__firefox__')
    || String(msg).includes('window.ethereum')) {
    return;
  }
  const errMessage = `URL: ${location.href}
ファイル名: ${file}
環境: ${navigator.userAgent}
行: ${line}, 列: ${col}
${err ? err.stack : err || ''}`;
  notifyAdmin(errMessage, msg || '');
};

delete window.process;